import {
    APIConnectionFirmsRecord,
    APIConnectionRecord,
    APIConnectionUsersRecord
} from '@tassat/fred-definitions';
import { UserRecordExtended } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';

import {
    getApiConnectionFirms,
    getApiConnectionUsers,
    getApiConnections,
    getFirms,
    getUsers
} from './common';
import { getActiveApiTypes } from './userApiTypes';

const getApiConnectionFirmId = (_state: AdminState, apiConnectionFirmId: string) => apiConnectionFirmId;
const getFirmId = (_state: AdminState, firmId: string, _connectionId: string) => firmId;
const getApiFirm = (state: AdminState, apiConnectionFirmId: string) => state.apiConnectionFirms[apiConnectionFirmId];

const getApiConnectionFirmsArray = createSelector(
    getApiConnectionFirms, (apiConnectionFirmsList): APIConnectionFirmsRecord[] => {
        const apiConnectionFirms = Object.keys(apiConnectionFirmsList)
            .map(id => apiConnectionFirmsList[id])
            .filter(apiFirm => !apiFirm.IsDeleted);

        return apiConnectionFirms;
    }
);

export const getAPIConnectionsFromFirm = createSelector(
    [ getApiConnectionFirmsArray, getFirmId, getApiConnections, getFirms ],
    (apiFirms, firmId, apiConnections, firms) => {
        const apiFirmsList = apiFirms;
        const firmApiConnections = apiFirmsList
            .filter(apiFirm => apiFirm.FirmId === firmId)
            .map(apiFirm => {
                const apiConnection = apiConnections[apiFirm.APIConnectionId];
                const firm = firms[apiFirm.FirmId];

                return {
                    apiConnection: apiConnection,
                    apiFirm: apiFirm,
                    firm: firm
                };
            });

        return firmApiConnections;
    }
);

export const getAPIConnectionFirmMappingFromId = createSelector(
    [ getApiConnectionFirms, getApiConnections, getFirms, getApiConnectionFirmId ],
    (apiConnectionFirms, apiConnections, firms, apiConnectionFirmId) => {
        const apiFirm = apiConnectionFirms[apiConnectionFirmId];
        const apiConnection = apiConnections[apiFirm.APIConnectionId];
        const firm = firms[apiFirm.FirmId];

        if (!apiFirm) return;

        return {
            apiConnection: apiConnection,
            apiFirm: apiFirm,
            firm: firm
        };
    }
);

const getAPIUsersAndAPIConnectionId = createSelector(
    [ getUsers, getApiFirm, getActiveApiTypes ],
    (users, apiFirm, activeApiTypes) => {
        const firmId = apiFirm.FirmId;
        const userList = Object.keys(users)
            .map(id => users[id]);

        const list = userList.filter(user => (
            user.FirmId === firmId &&
            (user.IsTokenAPIUser || activeApiTypes[user.UserId]) &&
            !user.IsDeleted));

        return {
            list,
            connectionId: apiFirm.APIConnectionId
        };
    }
);

interface ApiUserList {
    apiConnection: APIConnectionRecord;
    apiUser: APIConnectionUsersRecord;
    user: UserRecordExtended;
}

export const getAPIConnectionUsersFromAPIFirmAndAPIConnection = createSelector(
    [ getApiConnectionUsers, getApiConnections, getUsers, getAPIUsersAndAPIConnectionId ],
    (apiConnectionUsers, apiConnections, users, apiUser) => {
        const apiUserList = [] as ApiUserList[];

        const apiConnectionUserList = Object.keys(apiConnectionUsers)
            .map(id => apiConnectionUsers[id]);
        const connectionUserList = apiConnectionUserList.filter(id => id.APIConnectionId == apiUser.connectionId && !id.IsDeleted);
        const userList = apiUser.list;

        connectionUserList.forEach(userConn => {
            if (userList.some((user) => userConn.UserId === user.UserId) && !userConn.IsDeleted) {
                apiUserList.push({
                    apiConnection: apiConnections[userConn.APIConnectionId],
                    apiUser: userConn,
                    user: users[userConn.UserId]
                });
            }
        });

        return apiUserList;
    }
);